import Link from 'next/link';
import { DetailedHTMLProps, HTMLAttributes } from 'react';
import LetslinkIcon from '../public/logo/letslink-logo.svg';
import LogoBlack from '../public/logo/logo-black.svg';
import HealthCase from '../public/logo/logo-healthCase.svg';
import LogoKeto from '../public/logo/logo-keto.svg';
import LogoIcon from '../public/logo/logo.svg';
import NFT from '../public/logo/nft.svg';
import TextLogoIcon from '../public/logo/text-logo.svg';
import WhiteLogoIcon from '../public/logo/white-logo.svg';

export type type =
  | 'primary'
  | 'white'
  | 'text'
  | 'letslink'
  | 'fitkonnekt'
  | 'keto'
  | 'healthCase'
  | 'nft';

export interface LogoProps
  extends DetailedHTMLProps<HTMLAttributes<SVGElement>, SVGElement> {
  appearance?: type;
  link?: string;
}

export default function Logo({
  appearance = 'primary',
  className,
  link = '/',
  ...props
}: LogoProps) {
  const logos: Record<type, JSX.Element> = {
    primary: <LogoIcon {...props} />,
    white: <WhiteLogoIcon {...props} />,
    text: <TextLogoIcon {...props} />,
    letslink: <LetslinkIcon {...props} />,
    fitkonnekt: <LogoBlack {...props} />,
    keto: <LogoKeto {...props} />,
    healthCase: <HealthCase {...props} />,
    nft: <NFT {...props} />,
  };

  return (
    <div className={className}>
      <Link href={link} prefetch={false}>
        <a aria-label="Mavinx">
          {logos[appearance] || <LogoIcon {...props} />}
          {/* <LogoPolandIcon {...props} itemProp="logo" /> */}
        </a>
      </Link>
    </div>
  );
}
